import {Box, Grid} from "@mui/system";
import style from "../../../assets/css/proposal.module.scss";
import {Link, useNavigate} from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Button,
  Breadcrumbs,
  Typography,
  Divider,
  Stack,
} from "@mui/material";
import {useFormik} from "formik";
import * as Yup from "yup";
import {useCallback, useEffect, useMemo, useState} from "react";
import {HiCurrencyDollar, HiOutlineClock} from "react-icons/hi2";
import GlobalDateField from "../../global-fields/GlobalDateField";
import GlobalTextField from "../../global-fields/GlobalTextField";
import GlobalModal from "../../global-fields/GlobalModal";
import {useDispatch, useSelector} from "react-redux";
import {selectAuthState} from "../../../store/authSlice";
import {selectDataStoreState, setDataStore} from "../../../store/dataSlice";
import {SiAdobeacrobatreader} from "react-icons/si";
import {ERR_MESSAGE, MANDATORY_QUES} from "../../../constants/constants";
import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import {removeCookies, toCapitalCase} from "../../../constants/helper";
import {selectUiState, setUiData} from "../../../store/uiSlice";
import {
  AGENT_EXHIBITIONS,
  EXHIBITIONS,
  REQUEST_CLAIM,
  REQUEST_EXHIBITION,
} from "../../../constants/apiConstant";
import dayjs from "dayjs";
import GlobalRadio from "../../global-fields/GlobalRadio";
import ExhibitionFormModal from "../../exhibition-form-modal/ExhibitionFormModal";
import {BsCheckSquare, BsExclamationSquare} from "react-icons/bs";
import NoDataComponent from "../../no-data";

const LossTypeMenuItems = [
  {name: "Mysterious Disappearance", value: "Mysterious Disappearance"},
  {name: "⁠Shipping", value: "⁠Shipping"},
  {name: "⁠Travel", value: "⁠Travel"},
  {name: "⁠Burglary", value: "⁠Burglary"},
  {name: "⁠Robbery", value: "⁠Robbery"},
  {name: "Other", value: "Other"},
];

const columns = [
  {id: "exhibition_id", label: "Exhibition ID", minWidth: 10},
  {id: "name", label: "Name", minWidth: 120},
  {id: "Transit", label: "Transit Type", minWidth: 80},
  {id: "Date", label: "Date", minWidth: 80},
  {id: "status", label: "Status", minWidth: 100},
  {id: "hard_quote", label: "Hard Quote Amt", minWidth: 110},
  {id: "soft_quote", label: "Soft Quote Amt", minWidth: 110},
  {id: "payment", label: "Payment", minWidth: 80},
  {id: "view", label: "View", minWidth: 80},
];

const rows = Array.from({length: 8}, (_, index) => ({
  exhibition_id: "xxxxxxxx" + (index + 1),
  name: "abc" + (index + 1),
  Transit: index == 1 || index == 2 ? "Including" : "Excluding",
  Date: "12/10/2025",
  hard_quote: "$12,00" + index,
  soft_quote: "$14,00" + index,
  status: index == 0 ? 0 : index == 1 ? 1 : 2,
  payment: index == 0 ? 0 : index == 1 ? 1 : 2,
  view: "VIEW",
  payment_status: index == 0 ? 0 : index == 1 ? 1 : 2,
}));

const ExhibitionCoverage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const isFirstRender = useRef(true);
  const {user} = useSelector(selectAuthState);
  const {
    exhibitionList,
    exhibitionCount,
    exhibitionParentProposal,
    remainingAggregate,
  } = useSelector(selectDataStoreState);
  const {showLoader} = useSelector(selectUiState);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  // const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);

  const exibitions = useMemo(
    () => (exhibitionList?.length ? exhibitionList : []),
    [exhibitionList]
  );
  const currentRowData = useMemo(() => currentRow, [currentRow]);
  // console.log("exhibitionParentProposal", exhibitionParentProposal);

  const [openExhibitionForm, setOpenExhibitionForm] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  // const fetchExhibitions = useCallback(async () => {
  //   if (page === null || rowsPerPage === null) {
  //     return;
  //   }
  //   dispatch(setUiData({showLoader: true}));

  //   let data = {
  //     user_id: user?.id,
  //     limit: rowsPerPage,
  //     offset: page * rowsPerPage,
  //   };

  //   const options = {
  //     method: EXHIBITIONS.method,
  //     headers: EXHIBITIONS.headers,
  //     body: JSON.stringify(data),
  //   };
  //   dispatch(setUiData({showLoader: false}));
  //   return;
  //   try {
  //     const response = await fetch(EXHIBITIONS.url, options);
  //     const res = await response.json();
  //     if (res.status == 1) {
  //       dispatch(
  //         setDataStore({
  //           exhibitionList: res?.exhibition_list || [],
  //           exhibitionCount: res?.total_count || 0,
  //         })
  //       );
  //     } else {
  //       console.error("Error fetching exhibition");
  //     }
  //     dispatch(setUiData({showLoader: false}));
  //   } catch (error) {
  //     removeCookies("isLogin");
  //     GlobalNotificationPopup({type: "error", message: error});
  //     dispatch(setUiData({showLoader: false}));
  //     navigate("/");
  //   }
  // }, [page, rowsPerPage]);

  const fetchExhibitions = useCallback(async () => {
    if (page == null || rowsPerPage == null || !user?.id) return;

    dispatch(setUiData({showLoader: true}));

    const data = {
      limit: rowsPerPage,
      offset: page * rowsPerPage,
      ...(user?.user_type === "agent"
        ? {agent_id: user.id}
        : {user_id: user.id}),
    };

    // if (user?.user_type === "agent") {
    //   data["agent_id"] = user?.id;
    // } else {
    //   data["proposal_id"] = exhibitionParentProposal?.proposal_id;
    // }
    data["proposal_id"] = exhibitionParentProposal?.proposal_id;
    const apiDetails = EXHIBITIONS;
    // user?.user_type === "agent" ? AGENT_EXHIBITIONS : EXHIBITIONS;

    const options = {
      method: apiDetails.method,
      headers: apiDetails.headers,
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(apiDetails.url, options);
      const res = await response.json();

      if (res.status == 1) {
        dispatch(
          setDataStore({
            exhibitionList: res?.exhibition_list || [],
            exhibitionCount: res?.total_count || 0,
            remainingAggregate: res?.formated_remaining_aggregate || "$0",
          })
        );
      } else {
        GlobalNotificationPopup({
          type: "error",
          message: res?.message || "Failed to fetch Exhibitions.",
        });
      }
    } catch (error) {
      removeCookies("isLogin");
      GlobalNotificationPopup({
        type: "error",
        message: error.message || "Something went wrong",
      });
      navigate("/");
    } finally {
      dispatch(setUiData({showLoader: false}));
    }
  }, [page, rowsPerPage, user]);

  useEffect(() => {
    // if (isFirstRender.current) {
    //   isFirstRender.current = false; // Prevent the second fetch caused by Strict Mode
    //   return;
    // }
    fetchExhibitions();
  }, [fetchExhibitions]);

  const handleSubmit = () => {
    setAnchorEl(null);
  };
  const handleOpenExhibitionForm = (row) => {
    setCurrentRow(row);
    setOpenExhibitionForm(true);
    dispatch(
      setUiData({
        exhibitionFormModal: true,
      })
    );
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePDF = (row) => {
    // console.log(" PDF:", row?.policy_file);
    if (!row?.policy_file) {
      console.error("Invalid PDF URL");
      return;
    }
    window.open(row?.policy_file, "_blank");
  };

  const handlePayment = async (row) => {
    dispatch(
      setDataStore({
        checkoutData: {
          proposal_id: exhibitionParentProposal?.proposal_id,
          id_forAPI: row.id,
          exhibition_id: row.exhibition_id,
          // hard_quote: row?.amount,
          formated_hard_quote: row?.formatted_amount,
          formated_hard_quote_with_Fee: row?.formatted_amount_with_fee,
          proposal_date: row?.date_reported,
          firm_name: row.firm_name,
        },
        checkoutRawData: row,
      })
    );
    navigate("/checkout");
  };

  const columns = [
    {
      id: "id",
      label: "#",
      minWidth: 50,
      renderCell: (_row, value) => value,
    },
    {
      id: "exhibition_id",
      label: "Exhibition ID",
      minWidth: 100,
      renderCell: (row) => `${row.exhibition_id}`,
    },
    {
      id: "transit_type",
      label: "Transit Type",
      minWidth: 100,
      renderCell: (row) => toCapitalCase(row.transit_type),
    },
    {
      id: "formatted_amount",
      label: "Amount",
      minWidth: 100,
    },
    {
      id: "date_reported",
      label: "Date Reported",
      minWidth: 120,
    },
    {
      id: "date_from",
      label: "Date From",
      minWidth: 120,
    },
    {
      id: "date_to",
      label: "Date To",
      minWidth: 120,
    },
    {
      id: "status",
      label: "Status",
      minWidth: 120,
      renderCell: (row) => {
        const statusMap = {
          0: (
            <Button
              disabled
              style={{color: "#ff8607"}}
              className={style.IssuedPolicyBtnDanger}
            >
              In Progress
            </Button>
          ),
          1: (
            <Button
              disabled
              style={{color: "#00ba34"}}
              className={style.IssuedPolicyBtnSucces}
            >
              Approved
            </Button>
          ),
          2: (
            <Button
              disabled
              style={{color: "#ff3d32"}}
              className={style.IssuedPolicyBtnExpired}
            >
              Declined
            </Button>
          ),
        };
        return (
          statusMap[row.payment_status] || (
            <span style={{color: "#FF2116"}}>N/A</span>
          )
        );
      },
    },
    {
      id: "payment_status",
      label: "Payment",
      minWidth: 100,
      renderCell: (row) => {
        if (user?.user_type === "agent") {
          // if (row.amount == 0)
          //   return <span style={{ color: "#FF2116" }}>N/A</span>;
          if (row.payment_status == 0)
            return <HiOutlineClock color="#ff8607" size={28} />;
          if (row.payment_status == 1)
            return <BsCheckSquare color="#00BA34" size={24} />;
          if (row.payment_status == 2)
            return <BsExclamationSquare color="#FF2116" size={24} />;
          return <span style={{color: "#FF2116"}}>N/A</span>;
        } else {
          return row.payment_status == 1 ? (
            <BsCheckSquare color="#00BA34" size={24} />
          ) : (
            <Button
              variant="contained"
              color="primary"
              size="small"
              style={{
                marginRight: 8,
                background: row.amount == 0 ? "#f1f1f1" : "#004F71",
              }}
              disabled={row.amount == 0}
              onClick={() => handlePayment(row)}
            >
              <HiCurrencyDollar />
              Pay
            </Button>
          );
        }
      },
    },
    {
      id: "pdf",
      label: "View",
      minWidth: 100,
      renderCell: (row) => (
        <Button
          variant="contained"
          color="primary"
          size="small"
          style={{
            marginRight: 8,
            background: "#F5F5F5",
            color: "#2C2C2C",
            padding: "4px 15px",
            border: "1px solid rgba(0, 0, 0, 0.11)",
          }}
          onClick={() => handlePDF(row)}
        >
          <SiAdobeacrobatreader
            style={{marginRight: "7px", fontSize: "18px"}}
            color="#FF2116"
          />
          PDF
        </Button>
      ),
    },
  ];
  const agentColumns = [
    ...columns.slice(0, 2), // for example, insert after index 1
    {
      id: "company",
      label: "Company Name",
      minWidth: 160,
      renderCell: (row) => row.company,
    },
    // {
    //   id: "full_name",
    //   label: "Client Name",
    //   minWidth: 160,
    //   renderCell: (row) => row.full_name,
    //   // renderCell: (row) => (
    //   //   <div>
    //   //     <Link to={"/details/client/" + row.user_id} style={{ color: "#000" }}>
    //   //       {row.full_name}
    //   //     </Link>
    //   //   </div>
    //   // )
    // },
    ...columns.slice(2),
  ];

  return (
    <>
      <Grid
        container
        spacing={3}
        className="customeContainer"
        justifyContent="center"
      >
        <Grid size={{xs: 12, lg: 12}} sx={{mt: 2}}>
          <div className={style.propPagination}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" to="/dashboard">
                Dashboard
              </Link>
              <Link underline="hover" color="inherit" to="/issued-policy">
                Issued Policies
              </Link>

              <Typography sx={{color: "grey"}}>Exhibition Coverage</Typography>
            </Breadcrumbs>
          </div>
        </Grid>
      </Grid>

      <section className={style.ProposalUnderProgessSection}>
        <Grid
          container
          spacing={3}
          className="customeContainer"
          justifyContent="center"
        >
          <Grid size={{xs: 12, lg: 12}}>
            <div className={style.propUnderProgTitle}>
              <div className={style.EndorsementsListTitle}>
                <h3> Exhibition Coverage List</h3>

                <Stack
                  direction={{xs: "column", sm: "row"}}
                  divider={<Divider orientation="vertical" flexItem />}
                  spacing={2}
                  sx={{mt: 0.5}}
                >
                  <p>
                    Policy Number:
                    <b style={{color: "#000"}}>
                      {" "}
                      {exhibitionParentProposal?.policy_number}
                    </b>
                  </p>
                  <p>
                    Remaining Aggregate:
                    <b style={{color: "#000"}}> {remainingAggregate ?? "$0"}</b>
                  </p>
                </Stack>
              </div>
              <Button
                sx={{
                  background: "rgb(0, 79, 113)",
                  textTransform: "capitalize",
                }}
                variant="contained"
                onClick={() => handleOpenExhibitionForm()}
              >
                Request New
              </Button>
            </div>

            <Paper className={style.propTableMain} sx={{mt: 1}}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      {(user?.user_type === "agent"
                        ? agentColumns
                        : columns
                      ).map((column) => (
                        <TableCell
                          style={{minWidth: column.minWidth}}
                          key={column.id}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                      {/* <TableCell> Actions </TableCell> */}
                    </TableRow>
                  </TableHead>
                  {exibitions?.length > 0 ? (
                    <TableBody>
                      {exibitions.map((row, rowIndex) => (
                        <TableRow key={row.id}>
                          {(user?.user_type === "agent"
                            ? agentColumns
                            : columns
                          ).map((column) => {
                            let value =
                              column.id === "id"
                                ? rowIndex + 1
                                : row[column.id];
                            return (
                              <TableCell
                                key={column.id}
                                style={{minWidth: column.minWidth}}
                              >
                                {column.renderCell
                                  ? column.renderCell(row, value)
                                  : value}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))}
                    </TableBody>
                  ) : null}
                </Table>
                {exibitions?.length > 0
                  ? null
                  : !showLoader && <NoDataComponent />}
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 15]}
                component="div"
                count={exhibitionCount || 0} // Use correct count
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                disabled={!exibitions.length}
              />
            </Paper>
          </Grid>
        </Grid>
      </section>

      <ExhibitionFormModal fetchListAgain={() => fetchExhibitions()} />
    </>
  );
};

export default ExhibitionCoverage;
